// Framework and third-party non-ui
import React from "react";

// App components

// JSON & Styles
import { StyledChip } from "./Chip-styled";

const Chip = ({ type, trailDifficulty }) => {
  if (type === "Difficulty") {
    return trailDifficulty ? (
      <div style={{ display: "inline-block" }}>
        <StyledChip difficulty={trailDifficulty} data-testid="Chip">
          {trailDifficulty}
        </StyledChip>
      </div>
    ) : null;
  } else if (type === "Closed") {
    return (
      <div style={{ display: "inline-block" }}>
        <StyledChip type={"Closed"} data-testid="Chip">
          Closed
        </StyledChip>
      </div>
    );
  } else if (type === "PartClosed") {
    return (
      <div style={{ display: "inline-block" }}>
        <StyledChip type={"PartClosed"} data-testid="Chip">
          Partially Closed
        </StyledChip>
      </div>
    );
  } else if (type === "Featured Route") {
    return (
      <div style={{ display: "inline-block" }}>
        <StyledChip type={"FeaturedRoute"} data-testid="Chip">
          Featured Route
        </StyledChip>
      </div>
    );
  }
};

export default Chip;
